module.exports = __webpack_public_path__ + "img/icon-action-plus.fba58f73.svg";